import { render, staticRenderFns } from "./InstallmentHistory.vue?vue&type=template&id=1453183b&scoped=true"
import script from "./InstallmentHistory.vue?vue&type=script&lang=js"
export * from "./InstallmentHistory.vue?vue&type=script&lang=js"
import style0 from "./InstallmentHistory.vue?vue&type=style&index=0&id=1453183b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1453183b",
  null
  
)

export default component.exports